import React, { useState } from 'react';
import { useToast } from '../hooks/use-toast';
import { submitLead } from '../api';

const ContactCTA = ({ defaultService = 'General Inquiry', heading = 'Ready to Launch Your Project?', subheading = 'Fill out the form below and we\u2019ll get back to you with a free, no obligation estimate.' }) => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast({ title: 'Missing info', description: 'Please add your name and email.' });
      return;
    }
    setLoading(true);
    try {
      await submitLead({ ...form, service: defaultService, source: 'CTA Form' });
      toast({
        title: 'Estimate Request Sent',
        description: `Thanks ${form.name}! Our team will contact you within 24 hours.`,
      });
      setForm({ name: '', email: '', phone: '', message: '' });
    } catch (err) {
      toast({
        title: 'Submission failed',
        description: err?.response?.data?.detail || 'Please try again in a moment.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-[#2C5F66] to-[#244e54]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="text-white text-3xl md:text-5xl font-extrabold mb-4">{heading}</h2>
          <p className="text-white/80 max-w-2xl mx-auto">{subheading}</p>
        </div>

        <form
          onSubmit={onSubmit}
          className="bg-white rounded-xl shadow-2xl p-8 md:p-10 grid md:grid-cols-2 gap-5"
        >
          <input
            name="name"
            value={form.name}
            onChange={onChange}
            placeholder="Full Name"
            className="border border-gray-200 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#2C5F66]"
          />
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={onChange}
            placeholder="Email Address"
            className="border border-gray-200 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#2C5F66]"
          />
          <input
            name="phone"
            value={form.phone}
            onChange={onChange}
            placeholder="Phone (optional)"
            className="md:col-span-2 border border-gray-200 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#2C5F66]"
          />
          <textarea
            name="message"
            value={form.message}
            onChange={onChange}
            placeholder="Tell us about your project\u2026"
            rows={4}
            className="md:col-span-2 border border-gray-200 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#2C5F66] resize-none"
          />
          <button
            type="submit"
            disabled={loading}
            className="md:col-span-2 bg-[#C68B30] hover:bg-[#B17A24] disabled:opacity-60 text-white font-semibold px-8 py-4 rounded-md transition-colors"
          >
            {loading ? 'Submitting\u2026' : 'Request Free Estimate'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactCTA;
